/**
 * Iter53 P47 — SaleFormContext + useSaleFormContext hook.
 *
 * Motivare: SaleForm.js are ~2000 LOC și trecere state prin 15+ props/tab ar rezulta
 * într-un refactor mai rău decât inline. Un Context la nivelul componentei părinte
 * permite extragerea tab-urilor în componente separate, self-contained.
 *
 * Câmpuri de bază (folosite de TOATE tab-urile):
 *   - formData        — obiectul cu toate câmpurile formularului
 *   - handleChange    — (fieldName, value) => void
 *   - canWrite        — (fieldKey) => bool (RBAC per câmp)
 *   - isHidden        — (fieldKey) => bool (RBAC per câmp)
 *   - isEdit          — bool (true la /sales/{id}/edit, false la /sales/new)
 *
 * Câmpuri suplimentare pentru tab-ul „Detalii vânzare" (Iter53 P47), grupate în `details`:
 *   - details.selectedClient / details.setSelectedClient
 *   - details.showNewClient / details.setShowNewClient
 *   - details.clientSearchOpen / setClientSearchOpen
 *   - details.clientSearchTerm / setClientSearchTerm
 *   - details.clientSearchResults / details.searchingClients
 *   - details.duplicates
 *   - details.handleSelectClient
 *   - details.getClientDisplayName
 *   - details.suppliers / details.salesChannels / details.statuses
 *   - details.getDistributionZonesForCommodity
 *   - details.isAdminOrBO
 */
import { createContext, useContext } from "react";

const SaleFormContext = createContext(null);

export const SaleFormProvider = ({
  formData,
  handleChange,
  canWrite,
  isHidden,
  isEdit,
  details = null,
  children,
}) => (
  <SaleFormContext.Provider
    value={{ formData, handleChange, canWrite, isHidden, isEdit, details }}
  >
    {children}
  </SaleFormContext.Provider>
);

export const useSaleFormContext = () => {
  const ctx = useContext(SaleFormContext);
  if (!ctx) {
    throw new Error(
      "useSaleFormContext must be used inside <SaleFormProvider> (Iter53 P47)"
    );
  }
  return ctx;
};

export default SaleFormContext;
